<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5571 3.55735C11.8011 3.31342 12.1978 3.31371 12.4419 3.55735C12.686 3.80143 12.686 4.19804 12.4419 4.44212L8.88428 7.99973L12.4419 11.5573C12.686 11.8014 12.686 12.198 12.4419 12.4421C12.1978 12.6862 11.8012 12.6862 11.5571 12.4421L7.99952 8.8845L4.4419 12.4421C4.19782 12.6862 3.80121 12.6862 3.55714 12.4421C3.3135 12.198 3.31321 11.8013 3.55714 11.5573L7.11475 7.99973L3.55714 4.44212C3.3135 4.198 3.31321 3.80128 3.55714 3.55735C3.80107 3.31342 4.19779 3.31371 4.4419 3.55735L7.99952 7.11497L11.5571 3.55735Z" fill="currentColor"/>
  </svg>
</template>

<script setup lang="ts">

</script>
